module.exports = __webpack_public_path__ + "static/media/features_target.cd66b792.svg";